<template>
    <vue-scroll>
        <single
            v-if="order && calendar"
            mode="edit"
            :calendar="calendar"
            :order="order"
        />
    </vue-scroll>
</template>

<script>
import FontCalibrationTool from "@/components/FontCalibrationTool.vue";
import * as ROLES from "@/constants/roles";
import { mapGetters, mapState } from "vuex";
import Single from "../calendar/Single";

export default {
    beforeRouteEnter(to, from, next) {
        Promise.all([
            axios.get(
                `/web-api/order/${to.params.id}?include=items.sizes.size`
            ),
            axios.get(
                `/web-api/calendar/${to.query.item_id}?include=events.deleted_events,location_keys,formatted_logo,logo,pricing,community.locations,location`
            )
        ]).then((response) => {
            next((vm) => vm.setData(response));
        });
    },
    components: {
        Single,
        FontCalibrationTool
    },
    data() {
        return {
            order: null,
            calendar: null
        };
    },
    computed: {
        ...mapState({
            boldMap: (state) => state.config.settings.font.bold_map
        }),
        ...mapGetters(["userRoles", "hasAnyRole", "userRoles"]),
        isCalibrationToolAllowed() {
            return this.hasAnyRole(ROLES.MAIN_ROLES);
        }
    },
    methods: {
        setData(responses) {
            this.order = responses[0].data;
            this.calendar = responses[1].data;
        },
        handleCalibrationResults(results) {
            this.$store.commit("setFontCalibrationResults", results);
        }
    }
};
</script>

<style scoped>
/* Add styling for the tool if needed */
.font-calibration-container {
    margin-top: 20px;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}
</style>
